module.exports = __webpack_public_path__ + "static/img/pre_btn.f3ca1648.png";